export default __webpack_public_path__ + "static/media/group-55.f1f05bc8.svg";